import * as React from 'react';
import { IBacAction } from '../models';
import { useData } from '../core/context/ProvidersContext';

export function useBacActions(filter?: { bacId?: number; bacIds?: number[]; type?: string }): {
  actions: IBacAction[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
} {
  const data = useData();
  const [actions, setActions] = React.useState<IBacAction[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  // Stable dep key so we don't refetch on every parent render.
  const depKey = JSON.stringify({
    bacId: filter?.bacId,
    bacIds: filter?.bacIds ? [...filter.bacIds].sort() : undefined,
    type: filter?.type,
  });

  const refresh = React.useCallback(() => {
    setLoading(true);
    setError(null);
    data.getBacActions(filter)
      .then(setActions)
      .catch((err: Error) => setError(err.message))
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, depKey]);

  React.useEffect(() => { refresh(); }, [refresh]);

  return { actions, loading, error, refresh };
}
